(function () {
  'use strict';

  var STORAGE_KEY = 'nodus_popup_dismissed';
  var SESSION_KEY = 'nodus_popup_shown';
  var DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

  function readDismissedAt() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      return value ? parseInt(value, 10) : null;
    } catch (error) {
      return null;
    }
  }

  function isDismissed() {
    var dismissedAt = readDismissedAt();
    if (!dismissedAt) return false;
    return Date.now() - dismissedAt < DISMISS_MS;
  }

  function wasShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markShownThisSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {
      /* ignore */
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {
      /* ignore */
    }
  }

  function shouldShowPopup(root) {
    if (!root) return false;
    if (root.dataset.enabled === 'false') return false;
    if (window.Shopify && window.Shopify.designMode) return true;
    if (isDismissed()) return false;
    if (wasShownThisSession()) return false;
    return true;
  }

  function openPopup(root) {
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nodus-popup-open');

    var closeBtn = root.querySelector('[data-nodus-popup-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup(root) {
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nodus-popup-open');
    markDismissed();
  }

  function initPopup(root) {
    if (!shouldShowPopup(root)) return;

    if (!(window.Shopify && window.Shopify.designMode)) {
      markShownThisSession();
    }

    var delay = parseInt(root.dataset.openDelay || '800', 10);

    window.setTimeout(function () {
      if (root.dataset.enabled === 'false') return;
      if (!(window.Shopify && window.Shopify.designMode) && isDismissed()) return;
      openPopup(root);
    }, delay);

    root.querySelectorAll('[data-nodus-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(root);
      });
    });

    var overlay = root.querySelector('.nodus-popup__overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        closePopup(root);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-visible')) {
        closePopup(root);
      }
    });
  }

  function boot() {
    var root = document.getElementById('nodus-popup');
    if (root) initPopup(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
